<template>
  <div></div>
</template>

<script>
export default {
  name: "AutoLogin",
  mounted() {
    this.autoLogin();
  },
  methods: {
    autoLogin() {
      console.log(this.$route);
      if (this.$route.query.un && this.$route.query.md5) {
        let un = this.$route.query.un;
        let md5 = this.$route.query.md5;
        this.loginJump(un, md5);
      } else {
        if (localStorage["token"]) {
          this.$router.push({
            name: "Login",
            query: {
              redirect: this.$route.query.redirect ? this.$route.query.redirect : "",
            },
          }); // 将跳转的路由path作为参数，登录成功后跳转到该路由
        }
      }
    },
    loginJump(un, md5) {
      this.axios
        .post(window.url + "Jumplogin", {
          Account: un,
          Password: md5,
        })
        .then((res) => {
          let data = res.data;
          if (res.data.result == 200) {
            // 保存登录信息
            localStorage.setItem("token", data.data.token);
            localStorage.setItem("UserID", data.data.Rid);
            localStorage.setItem("Name", data.data.Name);
            localStorage.setItem("TeacherID", data.data.TeacherID);
            localStorage.setItem("SchoolID", data.data.SchoolID);
            sessionStorage.setItem("un", un);
            sessionStorage.setItem("Md5", md5);
            if (this.$route.query.redirect != null) {
              this.$router.push(this.$route.query.redirect);
            } else {
              //跳到主页.
              this.$router.push({ name: "Classroom" });
            }
          } else {
            this.$message.error(res.data.message);
            this.$router.push({
              name: "Login",
              query: {
                redirect: this.$route.query.redirect ? this.$route.query.redirect : "",
              },
            });
          }
        })
        .catch((err) => {
          this.$message.error("加载失败, 请尝试重新登录");
          this.$router.push({
            name: "Login",
            query: {
              redirect: this.$route.query.redirect ? this.$route.query.redirect : "",
            },
          });
        });
    },
  },
};
</script>

<style lang="less" scoped>
.el-main {
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/AutoLogin.vue